import { render, staticRenderFns } from "./ProductColumnList.vue?vue&type=template&id=44d09176&scoped=true"
import script from "./ProductColumnList.vue?vue&type=script&lang=js"
export * from "./ProductColumnList.vue?vue&type=script&lang=js"
import style0 from "./ProductColumnList.vue?vue&type=style&index=0&id=44d09176&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d09176",
  null
  
)

export default component.exports